import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND, ROUTES } from '@/lib/constants';

export const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-[var(--ns-bg)]">
      {/* Lado visual — coherente con el hero de la home */}
      <aside className="relative hidden lg:flex lg:w-[48%] xl:w-[46%] overflow-hidden">
        <img
          src={BRAND.heroBgUrl}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-center"
          aria-hidden="true"
          draggable={false}
        />
        {/* Overlays: gradiente cálido + viñeta para legibilidad */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(160deg, rgba(28,22,18,0.35) 0%, rgba(28,22,18,0.70) 55%, rgba(28,22,18,0.90) 100%)',
          }}
          aria-hidden="true"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(120% 80% at 50% 40%, rgba(0,0,0,0) 45%, rgba(0,0,0,0.55) 100%)',
          }}
          aria-hidden="true"
        />

        <div className="relative z-10 p-10 xl:p-14 flex flex-col justify-between text-white w-full">
          <Link to={ROUTES.home} className="inline-flex items-center gap-2 group">
            <span className="font-display uppercase tracking-[0.22em] text-2xl xl:text-3xl text-white drop-shadow-[0_4px_16px_rgba(0,0,0,0.6)]">
              NetScouters
            </span>
          </Link>

          <div className="max-w-lg">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[var(--ns-gold)] font-semibold mb-4 drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">
              Plataforma deportiva · Clubes · Jugadores · Talento
            </p>
            <h2 className="font-display uppercase text-4xl xl:text-5xl leading-[1.02] drop-shadow-[0_4px_18px_rgba(0,0,0,0.7)]">
              Donde el deporte
              <br />
              se ve, se entiende
              <br />
              y <span className="text-[var(--ns-gold)]">evoluciona</span>.
            </h2>
            <p className="mt-5 text-sm xl:text-base text-white/85 leading-relaxed drop-shadow-[0_2px_10px_rgba(0,0,0,0.55)]">
              Tecnología deportiva para clubes, jugadores, partidos y talento
              del deporte base.
            </p>
          </div>
        </div>
      </aside>

      {/* Lado formulario */}
      <main className="flex-1 flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <Link
            to={ROUTES.home}
            className="lg:hidden flex items-center justify-center mb-6"
          >
            <img
              src={BRAND.logoUrl}
              alt="NetScouters"
              className="h-8 w-auto"
              draggable={false}
            />
          </Link>
          {title && (
            <h1 className="font-display uppercase tracking-tight text-[var(--ns-text)] text-3xl sm:text-4xl leading-[1.05]">
              {title}
            </h1>
          )}
          {subtitle && (
            <p className="mt-2 text-sm text-[var(--ns-text-muted)]">
              {subtitle}
            </p>
          )}
          <div className="mt-6">{children}</div>
        </div>
      </main>
    </div>
  );
};
